import { useQuery } from "@tanstack/react-query";
import { isImpersonating$, userPermissions$ } from "../state/permissions";
import { OPP_AUTHZ } from "../utils/runtimeConfig";
const hasPermissions = (userPerms) => userPerms != null &&
    Array.isArray(userPerms.roles) &&
    Array.isArray(userPerms.permissions);
export const setImpersonatedUserPermissions = (impersonatedPermissions) => {
    if (impersonatedPermissions && hasPermissions(impersonatedPermissions)) {
        userPermissions$.value = impersonatedPermissions;
        isImpersonating$.value = true;
    }
    else {
        userPermissions$.value = null;
        isImpersonating$.value = false;
    }
};
export const useGetUserPermissions = (fetchApi) => {
    const enabled = OPP_AUTHZ && isImpersonating$.value !== true;
    useQuery({
        queryKey: ["opp-user-permissions"],
        enabled,
        retry: false,
        staleTime: 0,
        queryFn: async () => {
            const res = await fetchApi.jsonInJsonOut(`/opp/permissions`);
            const permissions = res?.payload ?? null;
            if (permissions != null) {
                userPermissions$.value = permissions;
            }
            return permissions;
        },
    });
};
//# sourceMappingURL=oppAuthApi.js.map